import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { InputElementBase } from '../utils/types';
import { SelectOptionGroups } from '@/data/types';

export function SelectInputGroup({
  label,
  description,
  disabled,
  placeholder,
  name,
  onChange,
  ref,
  value,
  className,
  selectOptionGroups,
}: Exclude<InputElementBase, 'icon' | 'type' | 'className'> & {
  selectOptionGroups: SelectOptionGroups;
}) {
  return (
    <FormItem ref={ref}>
      {label && <FormLabel>{label}</FormLabel>}
      <Select
        disabled={disabled || undefined}
        onValueChange={onChange}
        defaultValue={value as string}
        name={name}
      >
        <FormControl>
          <SelectTrigger className={className || undefined}>
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          {selectOptionGroups.map((group) => (
            <SelectGroup key={group.groupLabel}>
              <SelectLabel>{group.groupLabel}</SelectLabel>
              {group.options.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectGroup>
          ))}
        </SelectContent>
      </Select>

      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  );
}
